






































import Vue from "vue";
import configProvider from "@/services/configProvider";

export default Vue.extend({
  data() {
    return {
      logoUrl: configProvider.get("LOGO_URL") || "",
      hideLogo: false,
    };
  },
  created() {
    this.hideLogo = configProvider.get("HIDE_LOGO", false);
  },
  methods: {
    getImg() {
      return require("../../assets/images/MSuite-mau.svg");
    }
  }
});
